import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import rootReducer from "../Reducers/rootReducer";

const store = configureStore({
  reducer: rootReducer,

  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  // If you have other middleware, you can add them here as well
  // Redux DevTools Extension is enabled by default in development mode
});
export default store;
